import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
export default {
  name: "RealNameRecords",
  data: function data() {
    return {
      userAuthDialogVisible: false,
      currentRow: {},
      userAuthDialogType: 1
    };
  },
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    queryApi: {
      type: String,
      default: 'setCityMasterAuth'
    }
  },
  methods: {
    showUserAuthDialog: function showUserAuthDialog(row, type) {
      this.userAuthDialogType = type;
      if (!row.phone) {
        var _row$user_info;
        row.phone = row.user_phone || '';
        row.name = (row === null || row === void 0 || (_row$user_info = row.user_info) === null || _row$user_info === void 0 ? void 0 : _row$user_info.name) || '';
      }
      this.currentRow = row;
      this.userAuthDialogVisible = true;
    },
    setQuarterUserAuth: function setQuarterUserAuth() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.$api[_this.queryApi]({
                phone: _this.currentRow.phone
              });
            case 1:
              res = _context.v;
              if (res.code === 4037) {
                _this.$confirm("该用户的版本信息较老，暂不支持去实名哦", "注意", {
                  confirmButtonText: "好的",
                  cancelButtonText: "返回",
                  showConfirmButton: false,
                  type: "warning"
                }).then(function () {
                  _this.userAuthDialogVisible = false;
                });
              } else {
                // 操作上报
                _this.$operationLog.push({
                  code: _this.userAuthDialogType == 1 ? "identify" : "reidentify",
                  userId: _this.currentRow.id,
                  operationType: "user"
                });
                _this.userAuthDialogType = 1;
                _this.$message.success("操作成功");
                _this.userAuthDialogVisible = false;
                _this.$emit("reload");
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    toPage: function toPage(row) {
      if (row !== null && row !== void 0 && row.idcardNumber) {
        window.open("#/user/real-name?number=".concat(row.idcardNumber));
      }
    }
  }
};